<section id="headC">
    <!-- <h1>Gedenkseite von:</h1> -->
    <div id="verstorbenenDaten" style="width:100%;">
        <div style="width:100%;">
            <!-- <h2>Gedenkseite von:</h2> -->
            <div id="name" class="topP">
                <span>Gedenken an</span>  {{ verstorbenenVorName }} {{ verstorbenenName }}
            </div>
                <div class="flexH">
                        <div id="geburtsdatum" *ngIf="verstorbenenGeburtsdatum != '0000-00-00'">
                            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                                <path
                                    fill="currentColor"
                                    d="M21 13H14.4L19.1 17.7L17.7 19.1L13 14.4V21H11V14.3L6.3 19L4.9 17.6L9.4 13H3V11H9.6L4.9 6.3L6.3 4.9L11 9.6V3H13V9.4L17.6 4.8L19 6.3L14.3 11H21V13Z"
                                />
                            </svg>

                            {{ verstorbenenGeburtsdatum | date: "dd.MM.yyyy" }}
                        </div>

                        <div id="sterbedatum">
                            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                                <g>
                                    <path
                                        fill="currentColor"
                                        d="M10.5,2H13.5V8H19V11H13.5V22H10.5V11H5V8H10.5V2Z"
                                    />
                                </g>
                            </svg>

                            {{ verstorbenenSterbedatum | date: "dd.MM.yyyy" }}
                        </div>
                </div>
        </div>
    </div>
    <div class="btn_holder">
        <button class="btn mat-button" [routerLink]="['/']">
            zurück zur Übersicht!
        </button>
    </div>
</section>
<mat-tab-group mat-align-tabs="start">
    <mat-tab label="Trauerkarte">
        <div *ngIf="KarteArr && KarteArr.length > 0" id="img_trauerkarte">
            <img
                src="{{ KarteArr[0].ta_trauerkartePfad }}gr/{{
                    KarteArr[0].ta_imageanzeige
                }}"
                class="tr_karte"
            />
        </div>
    </mat-tab>
    <mat-tab label="Gedenkkerzen">
        <mat-card class="nopadding inputP">
            <mat-expansion-panel
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title> Gedenkkerze entzünden </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <form [formGroup]="formKerze" >
                        <mat-form-field appearance="fill">
                            <mat-label>Name</mat-label>
                            <input
                                matInput
                                required
                                [(ngModel)]="usernameKerze"
                                formControlName="name"
                            />
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>E-Mail</mat-label>
                            <input
                                matInput
                                type="email"
                                id="email"
                                name=""
                                required
                                [(ngModel)]="usermailKerze"
                                formControlName="email"
                                [class.is-invalid] = "1==1" 
                            />
                        </mat-form-field>


                        <br />
              
                        <mat-checkbox class="example-margin" formControlName="datenschutzKerze" required>
                        Ich habe die <a href="https://www.bestattungen-eckhardt.de/datenschutz.html" target="_blank">Datenschutzerklärung</a> gelesen und akzeptiere sie.
                        </mat-checkbox>

                        <br />
                        <mat-card-actions>
                            <button
                                mat-raised-button
                                type="submit"
                                color="primary"
                                (click)="sendFormValues()"
                            >
                                entzünden
                            </button>
                        </mat-card-actions>


                        <div *ngIf="formKerze.controls['name'].invalid && kerzenError" class="alert">
                                    Bitte geben Sie einen Namen an.
                        </div> 
                        <div *ngIf="formKerze.controls['email'].errors && kerzenError" class="alert">
                                 Geben Sie bitte eine gültige Mailadresse an.
                        </div> 
                        <div *ngIf="formKerze.controls['datenschutzKerze'].invalid && kerzenError" class="alert">
                                 Akzeptieren Sie bitte die Datenschutzerklärung.
                        </div> 



                    </form>
                </div>
                <!-- <div *ngIf="isSent"> -->
                <div [ngClass]="{ fadein: isSent }">
                    <h2></h2>
                    <p [hidden]="!isSent">
                        Eine E-Mail wurde an die angegebene Adresse
                        <strong>{{ usermailKerze }}</strong> gesendet.<br />
                        Bestätigen Sie bitte den in der Nachricht angegebenen
                        Link.
                    </p>
                </div>
            </mat-expansion-panel>
        </mat-card>
        <div class="detailHolder" *ngIf="KerzenArr.length != 0; else showEmpty">
            <ng-container *ngFor="let item of KerzenArr">
                <mat-card>
                    <div class="detailV">
                        <div class="kerze">
                            <img
                                src="/files/gedenkportal/assets/icons/kerze2.svg"
                                class="kerze_img"
                            />
                        </div>
                        <div class="person">
                            {{ item.ker_name }}<br />{{ item.ker_text }}<br />
                        </div>
                        <div class="kerzen_content">
                            entzündete am
                            <b>{{
                                item.ker_timestamp * 1000 | date: "dd.MM.yyyy"
                            }}</b>
                            diese Kerze
                        </div>
                    </div>
                </mat-card>
                <div *ngIf="KerzenArr.length == 0" class="noItems">Keine Kerzen vorhanden</div>
            </ng-container>
        </div>
        <ng-template class="detailHolder" #showEmpty>
            <ng-container class="noItems"><span class="noItems">Keine Kerzen vorhanden.</span></ng-container>
        </ng-template>
    </mat-tab>
    <mat-tab label="Kondolenzen">
        <mat-card class="nopadding inputP">
            <mat-expansion-panel
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title> Kondolenz schreiben </mat-panel-title>
                </mat-expansion-panel-header>

                <div>
                    <form [formGroup]="formKondolenz">
                        <mat-form-field appearance="fill">
                            <mat-label>Name</mat-label>
                            <input
                                matInput
                                required
                                [(ngModel)]="usernameKondolenz"
                                formControlName="name"
                            />
                            <!-- <span class="img"></span> -->
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>E-Mail</mat-label>
                            <input
                                matInput
                                type="email"
                                required
                                [(ngModel)]="usermailKondolenz"
                                email="true"
                                formControlName="email"
                                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"s
                            />
                            <!-- <span class="img"></span> -->
                        </mat-form-field>
                        <br />
                        <mat-form-field
                            class="example-full-width"
                            appearance="fill"
                        >
                            <mat-label>Kondolenztext</mat-label>
                            <textarea
                                matInput
                                placeholder="Kondolenztext"
                                formControlName="kondolenz"
                                id="kondolenzText"
                                required
                                [(ngModel)]="kondolenzText"
                            ></textarea>
                        </mat-form-field>
                        <br />
                        <mat-checkbox class="example-margin" formControlName="datenschutzKondolenz" required>
                            Ich habe die <a href="https://www.bestattungen-eckhardt.de/datenschutz.html" target="_blank">Datenschutzerklärung</a> gelesen und akzeptiere sie.
                            </mat-checkbox>
                        <br />


                        <mat-card-actions>
                            <button
                                mat-raised-button
                                color="primary"
                                (click)="sendFormValuesKondolenz()"
                            >
                                eintragen
                            </button>
                        </mat-card-actions>

                            <div *ngIf="formKondolenz.controls['name'].invalid && kondolenzError" class="alert">
                                Bitte geben Sie einen Namen an.
                            </div> 
                             <div *ngIf="formKondolenz.controls['email'].errors && kondolenzError" class="alert">
                                    Geben Sie bitte eine gültige Mailadresse an.
                            </div> 
                            <div *ngIf="formKondolenz.controls['kondolenz'].errors && kondolenzError" class="alert">
                                Geben Sie bitte einen Kondolenztext an.
                        </div> 
                           <div *ngIf="formKondolenz.controls['datenschutzKondolenz'].invalid && kondolenzError" class="alert">
                                    Azeptieren Sie bitte die Datenschutzerklärung.
                            </div>



                    </form>
                </div>
                <div *ngIf="isSentKondolenz">
                    <h2></h2>
                    <p>
                        Eine E-Mail wurde an die angegebene Adresse
                        <strong>{{ usermailKondolenz }}</strong>
                        gesendet.<br />bestätigen Sie den in der Nachricht
                        angegebenen Link.
                    </p>
                </div>
            </mat-expansion-panel>
        </mat-card>

        <div
            class="detailHolder"
            *ngIf="KondolenzenArr.length != 0; else showEmptyK"
        >
            <ng-container *ngFor="let item of KondolenzenArr">
                <mat-card class="kondolenzBox">
                    <div class="detailV">
                        <div class="person">{{ item.kon_name }}<br /></div>
                        <div>
                            schrieb am
                            <b>{{
                                item.kon_timestamp * 1000 | date: "dd.MM.yyyy"
                            }}</b>
                            folgendes
                        </div>
                        <div class="quotes first">
                            <img
                                src="/files/gedenkportal/assets/icons/quotes.svg"
                                class="quotes_img"
                            />
                        </div>
                        <div [innerHTML]="nlTobr(item.ko_text)" class="txt_kondolenz"></div>
                        <div class="quotes last">
                            <img
                                src="/files/gedenkportal/assets/icons/quotes.svg"
                                class="quotes_img"
                            />
                        </div>
                    </div>
                </mat-card>
            </ng-container>
        </div>
        <ng-template class="detailHolder" #showEmptyK>
            <ng-container class="noItems"><span class="noItems"> Keine Kondolenzen vorhanden. </span></ng-container>
        </ng-template>
    </mat-tab>
</mat-tab-group>
